(() => {
  const setupNavigation = () => {
    if (document.body.classList.contains('gio-product-detail-page')) return;

    const nav = document.querySelector('.gio-site-page .gio-lab-nav');
    if (!nav || nav.dataset.scrollAware === 'true') return;

    nav.dataset.scrollAware = 'true';
    let lastScrollY = Math.max(window.scrollY, 0);
    let scrollFrame = null;

    if (lastScrollY > 8) nav.classList.add('gio-lab-nav--hidden');

    const updateNavigation = () => {
      const currentScrollY = Math.max(window.scrollY, 0);
      const difference = currentScrollY - lastScrollY;
      const mobileMenuOpen = nav.querySelector('details[open]');

      if (currentScrollY <= 8 || mobileMenuOpen || difference < -1) {
        nav.classList.remove('gio-lab-nav--hidden');
      } else if (difference > 1) {
        nav.classList.add('gio-lab-nav--hidden');
      }

      lastScrollY = currentScrollY;
      scrollFrame = null;
    };

    window.addEventListener('scroll', () => {
      if (scrollFrame !== null) return;
      scrollFrame = window.requestAnimationFrame(updateNavigation);
    }, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupNavigation, { once: true });
  } else {
    setupNavigation();
  }
})();
